import {
  get,
  post,
  upload
} from '../common/request.js'
import {
  Loading
} from 'element-ui';
var url = ''
if (process.env.NODE_ENV === 'production') {
  //生产
  url = 'https://ximiyouyue.com/'
} else {
  //开发
  url = 'https://ximiyouyue.com/'
}

export function register(data) {
  //注册
  return post(url + 'api/User/register', data)
}

export function login(data) {
  //登录
  return post(url + 'api/User/login', data)
}

export function getUserInfo(data) {
  //获取个人信息
  return get(url + 'api/User/userinfo', data)
}

export function getNotice(data) {
  //获取公告
  return get(url + 'api/Goods/notice', data)
}

export function tuijian(data) {
  //相关推荐
  return post(url + 'api/goods/recomment', data)
}

export function liebiao(data) {
  //西区列表
  return get(url + 'api/Goods/list', data)
}

export function xaingqing(data) {
  //戏曲详情
  return get(url + 'api/Goods/detail', data)
}


export function pinglun(data) {
  //评论
  return post(url + 'api/Goods/comment', data)
}


export function huifu(data) {
  //回复评论
  return post(url + 'api/goods/reply', data)
}

export function collect(data) {
  //收藏
  return post(url + 'api/Goods/collect', data)
}

export function collectZhuti(data) {
  //收藏主体
  return post(url + 'api/goods/subCollect', data)
}

export function getzhutiDetail(data) {
  //主题详情
  return get(url + 'api/goods/sub_detail', data)
}

export function downLoadCenter(data) {
  //下载中心
  return get(url + 'api/goods/down_list', data)
}

export function likeClass(data) {
  //获取我喜欢类型
  return post(url + 'api/goods/like', data)
}

export function allClass(data) {
  //获取全部类型
  return post(url + 'api/Goods/cates', data)
}

export function addLikeClass(data) {
  //添加类型我喜欢的
  return post(url + 'api/goods/addLike', data)
}


export function myCollect(data) {
  //我的收藏
  return get(url + 'api/Goods/collect_list', data)
}

export function commonData(data) {
  //添加类型我喜欢的
  return post(url + 'api/Apeal/config', data)
}

export function addPoint(data) {
  //添加类型我喜欢的
  return post(url + 'api/goods/addPoints', data)
}

export function zan(data) {
  //添加类型我喜欢的
  return post(url + 'api/goods/love', data)
}


// WEBPACK FOOTER //
// ./src/api/api.js